import { AppBar, BottomNavigation, Box, Collapse, CssBaseline, Divider, Drawer, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from "@mui/material";
import { menuItems } from "./constants/constants";
import MainRouter from "./router/router";
import { useNavigate } from 'react-router-dom'
import { useCallback, useState } from "react";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./config/firebase";
import CuentaRegresiva from "./components/cuentaregresiva";
import { minWidth } from "@mui/system";
import { AlternateEmail, Facebook, Instagram } from "@mui/icons-material";

const drawerWidth = 300

function App() {

  const [active, setActive] = useState('/inicio');
  const [open, setOpen] = useState(false);

  initializeApp(firebaseConfig)

  const navigate = useNavigate()
  const handleRouting = useCallback((route) => {
    setActive(route)
    navigate(route, { replace: true })
  }, [navigate])

  return (
    <>
      <Box>
        <AppBar
          position="fixed"
          sx={{ background: "#ffffff" }}
        >
          <Toolbar>
            <Grid container alignItems='center' sx={{ flexFlow: 'nowrap' }}>
              <Grid item flexGrow={1}>
                <img width={200} src="/images/logo_congreso.jpg" />
              </Grid>
              <Grid item>
                <img width={180} src="/images/perezoso_cafe.png" />
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Drawer
          sx={{
            width: '35vw',
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: '35vw',
              mt: 18.7
            },
          }}
          variant="permanent"
          anchor="left"
        >
          <List disablePadding>
            {menuItems.map((item) => (
              <>
                <ListItem key={item.title} disablePadding sx={{
                  '&:hover, .active': {
                    backgroundColor: 'rgb(18,161,154)',
                    color: '#ffffff',
                    '& .icon': {
                      color: '#ffffff',
                    },
                  },
                }}>
                  <ListItemButton className={item.to === active ? 'active' : ''} onClick={() => item.to ? handleRouting(item.to) : setOpen(!open)}>
                    <ListItemIcon sx={{ minWidth: '3vh' }}>
                      <item.icon className="icon" sx={{ fontSize: '2vh' }} />
                    </ListItemIcon>
                    <ListItemText primary={item.title} sx={{ '& .MuiTypography-root': { fontSize: '2vh' } }} />
                  </ListItemButton>
                </ListItem>
                {item.subitems && <Collapse in={open}>
                  {item.subitems.map((subitem) => {
                    return (
                      <ListItem key={subitem.title} disablePadding sx={{
                        '&:hover, .active': {
                          backgroundColor: 'rgb(18,161,154)',
                          color: '#ffffff',
                          '& .icon': {
                            color: '#ffffff',
                          },
                        },
                      }}>
                        <ListItemButton sx={{ paddingLeft: '8%' }} className={subitem.to === active ? 'active' : ''} onClick={() => handleRouting(subitem.to)}>
                          <ListItemIcon sx={{ minWidth: '3vh' }}>
                            <subitem.icon className="icon" sx={{ fontSize: '2vh' }} />
                          </ListItemIcon>
                          <ListItemText primary={subitem.title} sx={{ '& .MuiTypography-root': { fontSize: '2vh' } }} />
                        </ListItemButton>
                      </ListItem>)
                  })}
                </Collapse>}
                <Divider />
              </>
            ))}
          </List>
          <Grid container justifyContent='center' p={1}>
            <Grid item>
              <iframe
                src={`https://www.youtube.com/embed/JNBgJgBSxfs`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Congreso CICOP 2023"
                width='100%'
              />
            </Grid>
          </Grid>
        </Drawer>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3, mt: 18.7 }}>
          <MainRouter />
        </Box>
      </Box >
      <Box>
        <footer style={{ position: "fixed", background: 'white', color: 'black', bottom: 0, width: '35vw', zIndex: 2000 }}>
          <Grid container flexDirection='column' alignItems='center' justifyContent='center' p={1} spacing={1}>
            <Grid item>
              <Grid container flexDirection='row' spacing={2}>
                <Grid item>
                  <a href='https://www.facebook.com/cicopcr/'>
                    <Facebook className="link" />
                  </a>
                </Grid>
                <Grid item>
                  <a className="link" href='https://instagram.com/cicopcr?igshid=YmMyMTA2M2Y='>
                    <Instagram className="link" />
                  </a>
                </Grid>
                <Grid item>
                  <a href='mailto:congreso2023@cicopcr.org'>
                    <AlternateEmail className="link" />
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </footer>
      </Box>
    </>
  );
}
export default App;
